/**
 * 하단 작업 줄(.actionbar) 같은 sticky 줄이 지금 화면 아래에 붙어 있는지 문서 최상위에 표시한다.
 *
 * <html data-bar-stuck="true|false">
 *
 * 화면 아래 모서리에 떠 있는 버튼 — 오른쪽 퀵 버튼(.quickbar) · 왼쪽 도움말(.helpbar) — 이
 * 이 값을 보고 줄 위로 비켜 선다. 페이지 끝까지 내려가 줄이 제자리(푸터 위)로 돌아가면 다시 내려온다.
 *
 * 바닥에 붙은 줄은 아래 끝이 화면 아래 끝과 같고, 제자리로 돌아간 줄은 그보다 위에 있다.
 * 스크롤 · 창 크기 · 줄 크기(감춰졌다 나타날 때 0 → 60px)가 바뀔 때 한 프레임에 한 번 잰다.
 *
 * IntersectionObserver 로 하지 않는 이유: 감춰졌다가 나타난 sticky 줄의 위치를 엉뚱하게 보고하고
 * 그 뒤 스크롤에는 알려 오지 않아(크롬), 붙었는지를 끝내 알 수 없었다.
 */

// 소수점 픽셀 반올림으로 아래 끝이 화면 끝보다 살짝 모자랄 수 있다
const TOLERANCE = 1;

const InitStickyBar = () => {
  // UI 키트의 견본처럼 static 으로 놓인 줄은 붙는 일이 없다
  const bars = [...document.querySelectorAll('.actionbar')].filter(
    (bar) => 'sticky' === window.getComputedStyle(bar).position
  );

  if (!bars.length) {
    return;
  }

  let frame = 0;

  const sync = () => {
    frame = 0;

    // sticky 의 bottom: 0 은 스크롤 영역(가로 스크롤바를 뺀 화면) 아래 끝을 기준으로 한다
    const edge = Math.min(window.innerHeight, document.documentElement.clientHeight);

    const stuck = bars.some((bar) => {
      // 감춰진 줄(hidden)은 상자가 없다
      if (!bar.getClientRects().length) {
        return false;
      }

      const rect = bar.getBoundingClientRect();

      return rect.top < edge && rect.bottom >= edge - TOLERANCE;
    });

    document.documentElement.dataset.barStuck = stuck ? 'true' : 'false';
  };

  const schedule = () => {
    if (!frame) {
      frame = window.requestAnimationFrame(sync);
    }
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);

  // 편집기가 데이터를 읽은 뒤 줄을 보이면(hidden 해제) 크기가 바뀐다 — 스크롤 없이도 다시 잰다
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    bars.forEach((bar) => observer.observe(bar));
  }

  sync();
};

export default InitStickyBar;
